var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 237.52 154.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .Ltcls1 {\n        fill: #fff;\n      }\n\n      .Ltcls-2 {\n        fill: none;\n      }\n\n      .Ltcls-2, .Ltcls-3 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .Ltcls-3 {\n        fill: #ff6261;\n      }\n\n      .Ltcls-4 {\n        fill: #eee;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_94",
    "data-name": "Layer 94"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-4",
    x: 21.9,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-2",
    x: 21.9,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_93",
    "data-name": "Layer 93"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls1",
    x: 32.05,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-2",
    x: 32.05,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_92",
    "data-name": "Layer 92"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls1",
    x: 100.37,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-2",
    x: 100.37,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_91",
    "data-name": "Layer 91"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls1",
    x: 167.85,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-2",
    x: 167.85,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_90",
    "data-name": "Layer 90"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls1",
    x: 32.47,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-2",
    x: 32.47,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_89",
    "data-name": "Layer 89"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls1",
    x: 100.78,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-2",
    x: 100.78,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_88",
    "data-name": "Layer 88"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls1",
    x: 168.26,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-2",
    x: 168.26,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_87",
    "data-name": "Layer 87"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls1",
    x: 32.47,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-2",
    x: 32.47,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_86",
    "data-name": "Layer 86"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls1",
    x: 100.78,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-2",
    x: 100.78,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_85",
    "data-name": "Layer 85"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls1",
    x: 168.26,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Ltcls-2",
    x: 168.26,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Ltcls-3",
    cx: 20.63,
    cy: 20.63,
    r: 20.13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/Light.e5d765147f49b53863c3dd0d0dfc311a.svg";
export { ForwardRef as ReactComponent };